import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import WorkAreaInputButton from '../../containers/Engineering/WorkAreaInputButton';

export default class WorkAreaRadioButtonGroup extends Component {
  renderLabelText() {
    if (this.props.labelHTML) {
      return <span dangerouslySetInnerHTML={{ __html: this.props.label }} />;
    } else {
      return this.props.label;
    }
  }

  render() {
    let innerClases = 'btn-group btn-group-sm pe-2';
    if (this.props.orientation === 'vertical') {
      innerClases += ' btn-group-vertical';
    }
    if (this.props.label.length === 0) {
      innerClases += ' no-label';
    }

    const buttonGroup = (
      <div className={innerClases} role="group" aria-label={this.props.label || 'Button group'}>
        {this.props.buttons.map((btn) => {
          let selected = this.props.values[btn.group];
          let active =
            selected !== false && selected === btn.params[btn.group];

          return (
            <WorkAreaInputButton
              key={'btn-' + this.props.node + '-' + btn.label}
              node={this.props.node}
              active={active}
              {...btn}
            />
          );
        })}
      </div>
    );

    if (this.props.label.length) {
      return (
        <fieldset className="button-group-fieldset border-0 pb-3 px-1">
          <div className="d-flex flex-row justify-content-between">
            <legend className="control-label float-none mb-0">
              {this.renderLabelText()}
            </legend>
            <div>
              {buttonGroup}
            </div>
          </div>
        </fieldset>
      );
    } else {
      return (
        <div className="d-flex flex-row justify-content-between pb-3 px-1">
          <div className="col-sm-12">
            {buttonGroup}
          </div>
        </div>
      );
    }
  }
}

WorkAreaRadioButtonGroup.defaultProps = {
  node: '',
  label: '',
  labelHTML: false,
  buttons: [],
  values: {},
  orientation: 'horizontal',
};

WorkAreaRadioButtonGroup.propTypes = {
  node: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelHTML: PropTypes.bool,
  buttons: PropTypes.array,
  values: PropTypes.object,
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
};
